"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Heading_1 = require("./Heading");
Object.defineProperty(exports, "Heading", { enumerable: true, get: function () { return Heading_1.Heading; } });
//# sourceMappingURL=index.js.map